import styled from 'styled-components';
import { PhotographyWrapper } from '../photography/PhotographyStyles';

// Share the established service-page typography, cards, FAQ, and booking layout.
export const DroneWrapper = styled(PhotographyWrapper)`
  .photo-hero-image { height: 500px; }
  .drone-intro { display: grid; grid-template-columns: 1fr 1fr; gap: 56px; align-items: center; }
  .drone-intro .photo-title { margin-bottom: 0; }
  .drone-intro .photo-copy { margin-bottom: 0; }
  .drone-details { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 40px; margin-top: 40px; }
  .drone-details p, .drone-format-grid p:not(.photo-eyebrow) { font: 400 17px/1.7 'Nunito Sans',sans-serif; color: #52617e; margin: 0; }
  .drone-details .photo-step-number { font-size: 20px; margin-bottom: 14px; }
  .drone-gallery-band { background: #f6f8fc; }
  .drone-gallery-band section { padding-top: 64px; padding-bottom: 64px; }
  .drone-gallery-band .photo-grid { grid-template-columns: repeat(2,minmax(0,1fr)); }
  .drone-gallery-band .image-card img { height: 380px; }
  .drone-format-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; margin-top: 36px; }
  .drone-format-grid article { border-top: 1px solid #cbd5e9; padding-top: 24px; }
  .drone-format-grid .photo-eyebrow { margin-bottom: 12px; }
  .drone-process { padding-bottom: 24px; }
  @media(max-width:991px) { .drone-intro { gap: 32px; } .drone-details { gap: 24px; } }
  @media(max-width:767px) {
    .photo-hero-image { height: 340px; }
    .drone-intro, .drone-details, .drone-format-grid { grid-template-columns: 1fr; gap: 24px; }
    .drone-details { margin-top: 28px; }
    .drone-details article { display: grid; grid-template-columns: 36px 1fr; column-gap: 16px; }
    .drone-details .photo-step-number { grid-row: span 2; }
    .drone-details p { grid-column: 2; font-size: 16px; }
    .drone-details h3 { font-size: 19px; margin-bottom: 8px; }
    .drone-gallery-band section { padding-top: 44px; padding-bottom: 44px; }
    .drone-gallery-band .photo-grid { grid-template-columns: repeat(2,minmax(0,1fr)); }
    .drone-gallery-band .image-card img { height: 200px; }


    .drone-format-grid { margin-top: 28px; gap: 28px; }
  }
`;
